<template>
  <div class="modal-card" style="min-width: 100px">
    <header class="modal-card-head">
      <p class="modal-card-title">Agents</p>
    </header>
    <section class="modal-card-body">
      <div>
        <div
          style="
            font-size: 18px;
            text-align: left;
            padding: 8px;
            border-radius: 12px;
            font-weight: bold;
          "
        >
          <div
            class="card has-border"
            style="margin-top: 5px; padding: 30px"
            :key="agent.id"
            v-for="agent of agents"
          >
            {{ agent.data().name }}
            <span style="display: inline-block; margin: auto; float: right"
              ><a :href="'tel:' + agent.data().number">
                <b-button type="is-success" icon-right="phone" /></a
            ></span>
            <span v-if="del" style="display: inline-block; margin-right:5px; float: right">
              <b-button
                @click="deleteAgent(agent.id)"
                type="is-danger"
                icon-right="delete"
              />
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import { mapState } from "vuex";
export default {
  props: {
    del: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agents: [],
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    async fetchAgentList() {
      let agents = await firebase
        .firestore()
        .collection("agents")
        .orderBy("name", "asc")
        .get();
      this.agents = agents.docs;
    },
    deleteAgent(uid) {
      this.$emit("DelAgent", uid);
      this.$parent.close();
    },
  },
  mounted() {
    this.fetchAgentList();
  },
};
</script>